<template>
  <custom-dialog width="1280px" :append-to-body="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding: 0 24px">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('components_refurbish_select_dialog.qsrjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table type="checkbox" v-model="selectDevice" :data="tableList" :column="tableColumn" tableCode="crm_stock_refurbish"  :filterArr="['action']" @sort="sortChange" @filter="filterChange">
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // tableCode: 'crm_stock_refurbish',
      formSearch: {
        search: '',
        orderBy: '',
        productCode: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        existBodyNumList: [],
        allowRenovate: 1, // 是否翻新
        stockState: 2
      },

      selectDevice: [],
      tableList: [],
      totalRows: 0
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      const bodyNumList = this.model.existBodyNumList.map(i => i.bodyNum);
      this.formSearch.existBodyNumList = bodyNumList;
      this.$getJSON(apis.stockOrderPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      this.visible = false;
      this.$emit('success', this.selectDevice);
    }
  }
};
</script>

<style lang="scss"></style>
